import {AnyAction} from 'redux'
import {
  PLACE_ORDER,
  UPDATE_ORDER,
  expressCheckout,
  getOrder,
  getOrderTicketsDownloadUrl,
  pollOrder,
} from '../actions/placed-order'
import {RESERVE_TICKETS} from '../actions/reservation'
import {PlacedOrderState} from '../types/state'

const defaultState: PlacedOrderState = {
  order: undefined,
  loadingTicketsUrl: true,
  orderPageUrl: null,
  chargeToken: null,
  clientStatus: null,
  pollEnded: false,
}

export const placedOrder = (state = defaultState, action: AnyAction): PlacedOrderState => {
  switch (action.type) {
    case PLACE_ORDER.SUCCESS:
    case UPDATE_ORDER.SUCCESS:
    case getOrder.fulfilled.toString():
      return {
        ...state,
        ...action.payload,
      }
    case pollOrder.fulfilled.toString():
      return {
        ...state,
        order: action.payload,
        pollEnded: true,
      }
    case pollOrder.rejected.toString():
      return {
        ...state,
        pollEnded: true,
      }
    case RESERVE_TICKETS.REQUEST:
      return defaultState
    case getOrderTicketsDownloadUrl.pending.toString(): {
      return {...state, loadingTicketsUrl: true}
    }
    case getOrderTicketsDownloadUrl.rejected.toString(): {
      return defaultState
    }
    case getOrderTicketsDownloadUrl.fulfilled.toString(): {
      if (!action.payload) {
        return defaultState
      }
      const {loadingTicketsUrl, downloadTicketsUrl} = action.payload
      return {...state, loadingTicketsUrl, downloadTicketsUrl}
    }
    case expressCheckout.fulfilled.toString(): {
      const {clientStatus} = action.payload
      return {...state, clientStatus}
    }
    default:
      return state
  }
}
